import { useContext, useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { getRecommendedTariffs, getUserDetails } from '../../api/Optimise';
import { AppContext } from '../../context/AppContext';
import withPageTitle from '../../hocs/withPageTitle';

import { WelcomeContainer, RecommendedContainer, TariffDetailsContainer } from './TariffRecommender';

const TariffRecommenderContainer = () => {
  const {
    setRecommendedTariffs,
    setUserSub,
    userSub,
    setLoadingRecommendedTariffs,
    setUserDetails,
    setTariffSimResponseGeneratedDate,
  } = useContext(AppContext);

  useEffect(() => {
    const asyncUseEffect = async () => {
      await getUserDetails()
        .then((userDetails) => {
          setUserDetails(userDetails);
          setUserSub(userDetails.user_sub);
        })
        .catch((e) => console.error(e));
    };
    asyncUseEffect();
  }, []);

  useEffect(() => {
    if (!!userSub) {
      setLoadingRecommendedTariffs(true);
      getRecommendedTariffs(userSub)
        .then((recommendedTariffs) => {
          // Extract status and updated timestamp from the response
          if (recommendedTariffs?.status === 'COMPLETE' && recommendedTariffs?.updated) {
            // Convert Unix timestamp to Date object
            const updatedDate = new Date(recommendedTariffs.updated * 1000);
            const generatedDate = updatedDate.toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            });

            setTariffSimResponseGeneratedDate(generatedDate);
          }

          // Sort by the value saved
          const sortedTariffs = recommendedTariffs?.tariff_sim_results.sort((a, b) => {
            const aValue = a.optimised_tariff_results.export_cost - a.optimised_tariff_results.import_cost;
            const bValue = b.optimised_tariff_results.export_cost - b.optimised_tariff_results.import_cost;
            return bValue - aValue;
          });
          setRecommendedTariffs(sortedTariffs);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          setLoadingRecommendedTariffs(false);
        });
    }
  }, [userSub]);

  return (
    <Switch>
      <Route path="/app/tariffs" exact>
        <Redirect to="/app/tariffs/welcome" />
      </Route>
      <Route path="/app/tariffs/welcome" exact>
        <WelcomeContainer />
      </Route>
      <Route path="/app/tariffs/recommended" exact>
        <RecommendedContainer />
      </Route>
      <Route path="/app/tariffs/recommended/:combinationId" exact>
        <TariffDetailsContainer />
      </Route>
    </Switch>
  );
};

export default withPageTitle('Tariff Recommender', TariffRecommenderContainer);
